import { Injectable } from '@angular/core';
import {DeviceModel, DeviceSectorization, InterferenceTestDeviceModel} from "../../models/grit/grit.device-model";
import {ModalControlService} from "../modal-control.service";
import {ModalConfirmationService} from "../modal-confirmation.service";
import {UiBlockService} from "../ui-block.service";
import {GritApiService} from "./grit.api.service";
import {ProjectService} from "../project.service";
import {PointsService} from "../points.service";
import {FeatureType} from "../../models/EnumTypes";
import {GritDynamicTableMode} from "../../models/grit/grit.enums";

@Injectable({
  providedIn: 'root'
})
export class GritInterferenceTestDeviceService {

  public selectedDevice: InterferenceTestDeviceModel = new InterferenceTestDeviceModel();

  public active = false;
  public editMode = false

  constructor(
    private modalService : ModalControlService,
    private modalConfirmation: ModalConfirmationService,    private uiBlock: UiBlockService,
    private gritAPIService: GritApiService,
    private projectService: ProjectService,
    private pointsService: PointsService,
  ){
  }

  hideTab(){
    this.active = false;
  }

  showTab(itDevice?: InterferenceTestDeviceModel){
    this.selectedDevice = new InterferenceTestDeviceModel();

    if (itDevice !== null){
      this.selectedDevice.fromDTO(itDevice);
    }

    this.active = true;
    this.editMode = false;
  }

  async deleteDevice(){
    if (!this.projectService.projectEditable()) return;
    let features = await this.pointsService.getGritSelected<InterferenceTestDeviceModel>(FeatureType.Device, GritDynamicTableMode.SELECT_MULTIPLE);

    if (features != null){
      this.modalConfirmation.showMesssageConfirmationModal(
        "Delete Devices",
        "Do you want to delete the selected devices?",
        "Yes", "No",
        () =>   {
          this.uiBlock.startBlock("Deleting devices...")

          return this.gritAPIService.itDeviceDelete(features.map(feature => feature.entity)).then(
            (devices) => {
              this.pointsService.removeGritFeaturesFromMap(features)
              this.modalService.showMesssageModal("Devices Delete", "Devices deleted with success.");
            },
            (error) => this.modalService.showMesssageModal("Devices Delete", "Error deleting the selected devices.")
          ).finally(() => this.uiBlock.stopBlock());
        });
    }
  }

  importItDevices(itDevices : InterferenceTestDeviceModel[]){
    this.modalConfirmation.showMesssageConfirmationModal(
      "Import Map RFI-Transmitters",
      "Do you want to import the Map RFI-Transmitters?",
      "OK", "Cancel",
      () => {
        this.uiBlock.startBlock("Importing Map RFI-Transmitters");
        this.gritAPIService.itDeviceCreate(itDevices).then(
          (itDevices) => {
            this.pointsService.addDevicesToMap(itDevices);
            this.modalService.showMesssageModal('Import Success', "Map RFI-Transmitters were successfully imported.");
          },
          (error) => {
            console.error(error)
            this.modalService.showMesssageModal('Import Failed', "Failed importing Map RFI-Transmitters. Check if structure is equal to export.");
          }
        ).finally(()=>this.uiBlock.stopBlock())
      }
    );
  }
}
